import { useSandbox } from "../context/SandboxContext";
import { useAuth } from "../context/AuthContext";
import { cn } from "./ui/kit";

const ROLES = [
  { id: "customer", label: "Customer", icon: "🍽️" },
  { id: "waiter", label: "Waiter", icon: "🧾" },
  { id: "kitchen", label: "Kitchen", icon: "🔥" },
  { id: "admin", label: "Admin", icon: "📊" },
  { id: "accounting", label: "Accounting", icon: "💳" },
  { id: "super_admin", label: "Super Admin", icon: "⚙️" },
];

export default function RoleSwitcher() {
  const { role, setRole, sync, processSync } = useSandbox();
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-zinc-950/80 glass">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-3 px-3 py-2 sm:px-5">
        <div className="flex items-center gap-2 pr-2">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-emerald-500 font-head text-base font-black text-zinc-950">R</span>
          <div className="leading-none">
            <div className="font-head text-sm font-extrabold tracking-wide text-white">RestoCore</div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-emerald-400">MSC Intelligence</div>
          </div>
        </div>

        {/* Sandbox role switcher */}
        <div className="order-3 w-full sm:order-2 sm:w-auto">
          <div className="flex items-center gap-1 rounded-full border border-white/10 bg-white/5 p-1">
            <span className="hidden px-2 text-[10px] font-bold uppercase tracking-wider text-amber-400 lg:inline">Sandbox</span>
            <div className="flex gap-1 overflow-x-auto no-scrollbar">
              {ROLES.map((r) => (
                <button
                  key={r.id}
                  data-testid={`role-switcher-${r.id}`}
                  onClick={() => setRole(r.id)}
                  className={cn(
                    "whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition-colors",
                    role === r.id ? "bg-emerald-500 text-zinc-950" : "text-zinc-300 hover:bg-white/10"
                  )}
                >
                  <span className="mr-1">{r.icon}</span>{r.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="order-2 ml-auto flex items-center gap-2 sm:order-3">
          {/* Offline / sync indicator */}
          {sync?.offline ? (
            <button
              data-testid="sync-indicator"
              onClick={processSync}
              className="flex items-center gap-2 rounded-full border border-rose-500/40 bg-rose-500/15 px-3 py-1.5 text-xs font-semibold text-rose-300 rc-pulse"
              title="Click to synchronize when connection returns"
            >
              <span className="h-2 w-2 rounded-full bg-rose-400" />
              OFFLINE · {sync.pending_sync} PENDING SYNC
            </button>
          ) : (
            <span data-testid="sync-indicator" className="flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1.5 text-xs font-semibold text-emerald-300">
              <span className="h-2 w-2 rounded-full bg-emerald-400" />
              ONLINE {sync?.pending_sync ? `· ${sync.pending_sync} PENDING` : "· SYNCED"}
            </span>
          )}
          <div className="hidden items-center gap-2 md:flex">
            {user?.picture && <img alt="" src={user.picture} className="h-7 w-7 rounded-full" />}
            <span className="text-xs text-zinc-400">{user?.name}</span>
          </div>
          <button
            data-testid="logout-btn"
            onClick={logout}
            className="rounded-full border border-white/10 px-3 py-1.5 text-xs font-semibold text-zinc-300 hover:bg-white/10"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}
